// extracted by mini-css-extract-plugin
export default {"container":"About_container__0T856","section_down_arrow":"About_section_down_arrow__7TWL+"};